/* src/app/features/habilitacao/conglomerado/novo-conglomerado/novo-conglomerado.component.scss */
.fundo-inativo {
  background-color: rgb(236, 236, 236);
}
/*# sourceMappingURL=novo-conglomerado.component.css.map */
